import React from "react";

const ISO_LOGO_URL = "https://rnrdeploynew.blob.core.windows.net/staticimages/iso270001_logo.png";

const IsoBadge = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      marginTop: 14,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <img src={ISO_LOGO_URL} alt="ISO 27001 Certified" style={{ height: 16, width: "auto" }} />
      <span style={{ fontSize: 11, color: "var(--ink-500, #6b7280)", fontWeight: 600 }}>
        ISO 27001 Certified
      </span>
    </div>

    <div style={{ width: 1, height: 12, background: "#d1d5db" }} />

    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <i className="fas fa-lock" style={{ fontSize: 11, color: "var(--ink-500, #6b7280)" }}></i>
      <span style={{ fontSize: 11, color: "var(--ink-500, #6b7280)", fontWeight: 600 }}>
        Data encrypted
      </span>
    </div>
  </div>
);

export default IsoBadge;
